// src/router/taxa.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['admin']

const taxaBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Taxas',
        to: 'Taxas'
    }
]

export default [
    {
        path: '/taxas',
        name: 'Taxas',
        component: () => import('@/views/Taxa/TaxaListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Taxa',
            breadcrumb: taxaBreadCrumb
        },
    },
    {
        path: '/taxas/nova',
        name: 'TaxaNova',
        component: () => import('@/views/Taxa/NovaTaxaPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Nova Taxa',
            breadcrumb: [
                ...taxaBreadCrumb,
                {
                    label: 'Nova Taxa',
                    to: 'TaxaNova'
                }
            ]
        }
    },
    {
        path: '/taxas/:id/detalhes',
        name: 'TaxaDetalhes',
        component: () => import('@/views/Taxa/NovaTaxaPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes da Taxa',
            breadcrumb: [
                ...taxaBreadCrumb,
                {
                    label: 'Nova Taxa',
                    to: 'TaxaNova'
                }
            ]
        }
    }
];
